import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {IgnoreNullHttpParams} from "../shared/commons/Ignore-null-http-params";
import {
  UserLk2TokenDto
} from "../../generated-model/model";
import {environment} from "../../environments/environment";
import {PageRequest} from "../app.constants";

@Injectable({providedIn: "root"})
export class UserLk2TokenResource {

  http = inject(HttpClient);

  public batchToken(pageRequest: PageRequest) {
    const param = IgnoreNullHttpParams.fromObject({...pageRequest}).toHttpParam()
    return this.http.get<UserLk2TokenDto[]>(`${environment.serverUrl}/api/user-lk2-token/batch/token`, {params: param});
  }

}
